import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ProviderNoteDetailModel } from 'src/app/models/shopping/provider-note-detail.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProviderNoteDetailService {

  private readonly _httpClient = inject(HttpClient);

  createProviderNoteDetail(providerNoteDetail: ProviderNoteDetailModel): Observable<ProviderNoteDetailModel> {
    return this._httpClient.post<ProviderNoteDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerNoteDetail.CreateAsync}`, providerNoteDetail);
  }

  createBulkProviderNoteDetail(providerNoteDetails: ProviderNoteDetailModel[]): Observable<ProviderNoteDetailModel[]> {
    return this._httpClient.post<ProviderNoteDetailModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerNoteDetail.CreateBulkAsync}`, providerNoteDetails);
  }

  deleteSomeDetails(providerNoteDetailIds: Array<number>): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerNoteDetail.DeleteSomeDetailsAsync}`,
      providerNoteDetailIds
    );
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());

    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerNoteDetail.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getArticleById(articleId: number): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerNoteDetail.GetArticleByIdAsync}/${articleId}`);
  }

  getArticlesForProviderNote(providerNoteId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams()
      .set('providerNoteId', providerNoteId)
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerNoteDetail.GetArticlesForProviderNoteAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForArticleCaptureProviderNote(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerNoteDetail.GetColumnsForArticleCaptureProviderNoteAsync}`);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerNoteDetail.GetColumnsForGeneralConsultation}`);
  }

  getColumnsForProviderNoteDetails(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerNoteDetail.GetColumnsForProviderNoteDetailsAsync}`);
  }

  getProviderNoteDetailByKeys(noteId: number, conceptInvoicingId: number, articleId: number | null): Observable<ProviderNoteDetailModel> {
    let params = new HttpParams()
    params = params.set('noteId', noteId)
    params = params.set('conceptInvoicingId', conceptInvoicingId)
    if (articleId !== null) params = params.set('articleId', articleId.toString());
    return this._httpClient.get<ProviderNoteDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerNoteDetail.GetProviderNoteDetailByKeysAsync}`, { params: params });
  }

  getProviderNoteDetailsByProviderNoteId(page: number, limit: number, columnSort: string | null, ascendant: boolean, providerNoteId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant)
      .set('providerNoteId', providerNoteId);

    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerNoteDetail.GetProviderNoteDetailsByProviderNoteIdAsync}`,
      { params }
    );
  }

  getProviderNoteDetailsForGeneralConsultation(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerNoteDetail.GetProviderNoteDetailsForGeneralConsultation}`,
      filters, { params: params }
    );
  }

  updateProviderNoteDetail(providerNoteDetail: ProviderNoteDetailModel): Observable<ProviderNoteDetailModel> {
    return this._httpClient.put<ProviderNoteDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerNoteDetail.UpdateAsync}`, providerNoteDetail);
  }

}
